import LoadingSpinner from '#atoms/LoadingSpinner';
import { Modal } from '#molecules';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { Suspense, useState } from 'react';
import styled from 'styled-components';
import { ChartExerciseMedia } from '../ChartExerciseMedia/ChartExerciseMedia';
import { MemberInfo } from '../MemberInfo/components/MemberInfo';
import { RoundInfo } from '../RoundInfo/RoundInfo';
import { useDashboardChartFormProcess } from '../hooks/useDashboardChartFormProcess';
import { ChartFormExerciseList } from './ChartFormExerciseList';
import { InfoSection } from './InfoSection';
import { SaveButton } from './SaveButton';
import { SendButton } from './SendButton';
import { TrainerFeedback } from './TrainerFeedback';

export const DashboardChartForm = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { save, exit } = useDashboardChartFormProcess();

  const onPreventPrevCallback = () => {
    setIsModalOpen(true);
  };

  return (
    <PrevHeaderBarWithTitleTemplate
      onPreventPrevCallback={onPreventPrevCallback}
      rightContents={<SaveButton />}
      title="운동차트 작성"
      defaultBackground
    >
      <div className="h-217">
        <Suspense fallback={<LoadingSpinner />}>
          <InfoSection />
        </Suspense>
      </div>
      <Divider />

      <div className="px-20 pb-32 pt-8">
        <Suspense
          fallback={
            <div className="flex justify-center items-center">
              <LoadingSpinner />
            </div>
          }
        >
          <ChartFormExerciseList />
        </Suspense>
      </div>
      <Divider />
      <div className="px-20 pb-32">
        <ChartExerciseMedia />
      </div>
      <Divider />
      <div className="px-20 py-32">
        <Suspense
          fallback={
            <div className="h-610 w-full flex justify-center items-center">
              <LoadingSpinner />
            </div>
          }
        >
          <MemberInfo />
        </Suspense>

        <Suspense
          fallback={
            <div className="h-610 w-full flex justify-center items-center">
              <LoadingSpinner />
            </div>
          }
        >
          <RoundInfo />
        </Suspense>
      </div>
      <Divider />

      <TrainerFeedback />

      <div className="pb-60" />

      <SendButton />

      {isModalOpen && (
        <Modal onClose={() => setIsModalOpen(false)}>
          <div className="text-center text-[#d7d2de] text-lg font-medium font-['Pretendard Variable'] leading-snug">
            입력한 내용이 소실돼요.
            <br />
            그래도 계속하시겠어요?
          </div>
          <div className="w-full flex gap-12 mt-20">
            <Button
              style={{ padding: '12px 0' }}
              buttonType="cancle"
              onClick={exit}
            >
              나가기
            </Button>
            <Button
              style={{ padding: '12px 0' }}
              buttonType="confirm"
              onClick={save}
            >
              임시저장 후 나가기
            </Button>
          </div>
        </Modal>
      )}
    </PrevHeaderBarWithTitleTemplate>
  );
};

const Divider = styled.div`
  height: 8px;
  background: var(--bg-800, #1e1b24);
`;

const Button = styled.button<{ buttonType: 'confirm' | 'cancle' }>`
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;

  background: ${({ buttonType }) =>
    buttonType === 'confirm'
      ? 'var(--Brand-400, #7750e9)'
      : 'var(--bg-600, #2e2a3a)'};

  color: ${({ buttonType }) =>
    buttonType === 'confirm'
      ? 'var(--Gray-Scale-100, #EBE9F4)'
      : 'var(--Gray-Scale-400, #bcb8c3)'};

  /* NEW/body_02_medium */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: -0.32px;
  white-space: nowrap;
`;
